import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import { CHART_COLORS } from '@/consts';
import { numberFormat } from '@/utils/unitUtils';

const buildData = (results, targetValue) => {
  const datasets = results.datasets.map((dataset, index) => ({
    data: dataset.data,
    label: dataset.label,
    borderColor: CHART_COLORS[index],
    backgroundColor: CHART_COLORS[index],
    pointBackgroundColor: CHART_COLORS[index],
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
    pointHoverBorderColor: CHART_COLORS[index],
    fill: false,
    tension: 0.1,
  }));

  if (targetValue != null) {
    datasets.push({
      data: results.labels.map(() => targetValue),
      label: 'Target',
      borderColor: '#94a3b8',
      backgroundColor: '#94a3b8',
      borderDash: [6, 4],
      pointRadius: 0,
      fill: false,
      tension: 0,
    });
  }

  return { labels: results.labels, datasets };
};

const buildOptions = (label, yAxisLabel, legendTitle, results, targetValue) => {
  const datasetCount = (results?.datasets?.length ?? 0) + (targetValue != null ? 1 : 0);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: datasetCount > 1,
        position: 'bottom',
        title: {
          display: datasetCount > 1,
          text: legendTitle,
          padding: 15,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: label,
        },
        ticks: {
          callback: function (_value, index, _ticks) {
            return numberFormat(results.labels[index]);
          },
        },
      },
      y: {
        title: {
          display: true,
          text: yAxisLabel,
        },
        ticks: {
          callback: function (value) {
            return numberFormat(value);
          },
        },
      },
    },
  };

  return options;
};

const LineChart = ({ results, label, legendTitle, yAxisLabel = '', targetValue }) => {
  const lineData = buildData(results, targetValue);
  const options = buildOptions(label, yAxisLabel, legendTitle, results, targetValue);
  return (
    <div className="min-h-80 relative mr-2">
      <Line data={lineData} options={options} />
    </div>
  );
};

LineChart.propTypes = {
  results: PropTypes.object,
  label: PropTypes.string,
  legendTitle: PropTypes.string,
  yAxisLabel: PropTypes.string,
  targetValue: PropTypes.number,
};

export default LineChart;
